import { render } from "./ParentComponet.vue?vue&type=template&id=4a6c7e7d"
import script from "./ParentComponet.vue?vue&type=script&lang=js"
export * from "./ParentComponet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__